module.exports = __webpack_public_path__ + "84442870.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/car-body/grey-outline/png/124/liftback-5.png
// module id = 2901
// module chunks = 33